export const fs1_p01 = 'La información publicada se encuentra en proceso de actualización debido a la reestructuración organizativa de las jurisdicciones y organismos de la Administración Pública Nacional.';
export const fs1_p01a = 'Contenido actualizado al: ';
export const fs1_p02 = 'Versión ';
export const fs1_p03 = 'Si encontrás un error o tenés algún comentario ';
export const fs1_a01 = ' contactate con nosotros';
export const firma1="Dirección Mapa del Estado"
export const firma2="Dirección Nacional de Diseño Organizacional"
export const mailMapa="mapadelestado@jefatura.gob.ar"
export const versionPortal="4.1.0"
export const pathJgm="https://www.argentina.gob.ar/jefatura"